<template>
    <div v-if="banners.length > 0" @mouseenter="hoverEvent(false)"
         @mouseleave="hoverEvent(true)">
        <v-carousel :cycle="cycleActive" height="fit-content" hide-delimiter-background interval="3000"
                    vertical :vertical-delimiters="$vuetify.breakpoint.mdAndUp ? 'vertical': undefined"
                    :show-arrows="false" class="rounded-lg overflow-hidden"
                    :hide-delimiters="$vuetify.breakpoint.xs">

            <v-carousel-item v-for="(slide, i) in banners" :key="i" eager :href="slide.link">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <img :src="coreLandUrl(slide.picture)" :alt="`img-${i}`" style="width: 100%" class="rounded"
                             v-bind="attrs" v-on="on">
                    </template>
                    <span>{{ slide.title }}</span>
                </v-tooltip>
            </v-carousel-item>
        </v-carousel>
    </div>
</template>

<script>
export default {
    name: "DashboardBaner",
    data() {
        return {
            banners: [],
            cycleActive: true,
        }
    },
    created() {
        this.getBanner()
    },

    methods: {
        getBanner() {
            this.requestApiGet('contentIndex?type=banner')
                .then(({data}) => {
                    this.banners = data.data;
                }).catch(({response}) => {

            })
        },
        openUrl(link) {
            window.open(link, '_blank')
        },
        hoverEvent(e) {
            this.cycleActive = e
        },
    }
}
</script>

<style scoped>

</style>